import { ProximityMapNonEmpty } from './implementation/index.mjs';
export function wrapHashMap(context, newInternalMap) {
    return newInternalMap.nonEmpty()
        ? new ProximityMapNonEmpty(context, newInternalMap)
        : context.empty();
}
//# sourceMappingURL=wrapping.mjs.map